<template>
  <section id="income" class="income">
    <div class="section-top-row">
      <div class="row row-narrow align-items-center no-print position-relative">
        <div class="col order-md-0 order-0">
          <h1>{{ $t('income') }}</h1>
        </div>
        <div class="col-auto table-view-navigator order-md-4 order-1">
          <DataTableExcel/>
        </div>
        <div class="col-auto order-md-5 order-2 table-view-navigator">
          <AddObject module="income"/>
        </div>
      </div>
    </div>
    <DataTable :options="options"
               module="income"/>
  </section>
</template>

<script>

import AddObject from "@/components/parts/datatable/AddObject"
import DataTable from "@/components/parts/general/DataTable"
import DataTableExcel from "@/components/parts/datatable/DataTableExcel"
import options from "@/data/income/other_income"
import { mapState } from "vuex"

export default {
  name: "Income",
  components: {
    AddObject,
    DataTableExcel,
    DataTable
  },
  head() {
    return {
      title: this.$t('income'),
    }
  },
  computed: {
    ...mapState({
      month: state => state.accounting.accountingmonth
    })
  },
  data() {
    return {
      options: options
    }
  },
  mounted() {
    this.$store.commit('setEloquentOptions', options)
  },
  beforeUnmount() {
    this.$store.commit('setAdditionalParams', {})
  }
}
</script>
